import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CacheService } from '../../../../../projects/common/src/app/services';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { UrlBuilderService } from 'projects/communication/src/app/services';

@Injectable({
  providedIn: 'root',
})
export class ReportOperationalDisciplineService {
  constructor(private cacheService: CacheService, private http: HttpClient, private urlBuilder: UrlBuilderService) {}

  public getReportOperationalDiscipline(selectedFilters: IOutputFilter): Observable<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.urlBuilder.apiUrl}/Report/GetOperationalDiscipline`;
    return this.http.get(url, { params }).pipe(catchError((err) => this.handleError(err)));
  }

  public getDetailReportOperationalDiscipline(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetOperationalDisciplineDetail`;
    return this.http.get(url, { params }).pipe(catchError((err) => this.handleError(err)));
  }

  public getReportOperationalDisciplineDocument(selectedFilters: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetOperationalDisciplineDetailReportDocument`;
    return this.http.get(url, { params: selectedFilters, responseType: 'blob' }).pipe(catchError((err) => this.handleError(err)));
  }

  /**
   * Function to set params and send selected filters to request
   *
   * @param selectedFilters Filters selected to save params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: String(selectedFilters.shiftId),
      machineList: selectedFilters.machineId,
      companyId,
    };
  }

  /**
   * Handle error
   *
   * @param err error
   */
  private handleError(err: any): Observable<any> {
    console.log(err);
    return throwError(err);
  }
}
